import React, { useState } from 'react';
import { ThemeProvider } from '../contexts/ThemeContext';
import { getThemeStyles } from '../styles/themes';

export const ThemeTest: React.FC = () => {
  const [currentTheme, setCurrentTheme] = useState('standard');
  const themes = ['standard', 'modern', 'bold', 'elegant', 'playful', 'dark', 'gradient', 'minimal'];
  
  const themeStyles = getThemeStyles(currentTheme);
  
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Theme Style Test</h1>
        
        {/* Theme Selector */}
        <div className="mb-8">
          <label className="block text-sm font-medium text-gray-700 mb-2">Select Theme:</label>
          <select 
            value={currentTheme} 
            onChange={(e) => setCurrentTheme(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg"
          >
            {themes.map(theme => (
              <option key={theme} value={theme}>{theme}</option>
            ))}
          </select>
        </div>
        
        {/* Current Theme Info */}
        <div className="mb-8 p-4 bg-white rounded-lg shadow">
          <h2 className="text-xl font-bold mb-4">Current Theme: {currentTheme}</h2>
          <pre className="text-xs overflow-auto">
            {JSON.stringify(themeStyles, null, 2)}
          </pre>
        </div>
        
        {/* Visual Preview */}
        <ThemeProvider theme={currentTheme}>
          <div className="space-y-8">
            {/* Navbar Preview */}
            <div>
              <h3 className="text-lg font-semibold mb-2">Navbar</h3>
              <div className={`p-4 ${themeStyles.navbar?.background} ${themeStyles.navbar?.text} ${themeStyles.navbar?.border} ${themeStyles.navbar?.shadow}`}>
                <div className="flex items-center justify-between">
                  <span className="font-bold">Logo</span>
                  <div className="space-x-4">
                    <span>Home</span>
                    <span>About</span>
                    <span>Contact</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Hero Preview */}
            <div>
              <h3 className="text-lg font-semibold mb-2">Hero</h3>
              <div className={`p-16 ${themeStyles.hero?.background} ${themeStyles.hero?.text}`}>
                <h1 className="text-4xl font-bold mb-4">Hero Title</h1>
                <p className="mb-6 opacity-90">This is the hero subtitle text</p>
                <button className={`px-6 py-3 rounded-lg ${themeStyles.hero?.buttonStyle}`}>
                  Get Started
                </button>
              </div>
            </div>
            
            {/* Visual Comparison */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <h4 className="font-semibold mb-2">Standard Theme (Reference)</h4>
                <div className="p-4 bg-gradient-to-br from-primary-600 to-primary-800 text-white rounded">
                  <p>Blue gradient background</p>
                  <button className="mt-2 btn-primary">Blue Button</button>
                </div>
              </div>
              <div>
                <h4 className="font-semibold mb-2">Modern Theme (Should be different)</h4>
                <div className="p-4 bg-white text-gray-900 rounded border">
                  <p>White background</p>
                  <button className="mt-2 bg-black text-white px-4 py-2 rounded hover:bg-gray-800">Black Button</button>
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </div>
    </div>
  );
};